import { DrawerItem } from 'src/types';

// Enums
export enum DrawerItemLabelEnum {
  Account = 'Account',
  Liability_Chart = 'Liability Chart',
  Liability_Schedule = 'Liability Schedule (BETA)',
  Audits = 'Audits',
  Branches = 'Branches',
  Sales_Section = 'Sales Section',
  Ecom_Orders = 'E-commerce Orders',
  CRMSales = 'CRM Sales',
  TapTap = 'TapTap',
  TapTapV2 = 'TapTap V2',
  TapTap_Report = 'TapTap Status Report',
  Customers_Queueing = 'Customers Queueing',
  Customers = 'Customers',
  PcwUser = 'Pcw-Users',
  Quotation = 'Quotation',
  QuotationV2 = 'QuotationV2',
  PC_Build_Gallery = 'Builds Gallery',
  Saved_Builds = 'User Saved Builds',
  Flash_Deals = 'Flash Deals',
  PC_Build = 'PC Build',
  Dashboard = 'Dashboard',
  Products = 'Products',
  Inventory = 'Inventory',
  Purchase_Orders = 'Purchase Orders',
  Purchase_Order_Reports = 'Purchase Order Reports',
  Product_In = 'Product In',
  Inventory_Audits = 'Inventory Audit',
  Inventory_Audits_Logs = 'Inventory Audit Logs',
  Categories = 'Categories',
  Suppliers = 'Suppliers',
  Manufacturers = 'Manufacturers',
  Sales = 'Sales',
  Roles_Permissions = 'Roles & Permissions',
  Price_List = 'Price List',
  Price_List_V2 = 'Price List v2',
  Manage_Users = 'Manage Users',
  Transactions = 'Transactions',
  Ecomm_Banners = 'Ecomm Banner',
  RMA = 'RMA',
  RMA_Inventory = 'RMA Inventory',
  Logout = 'Logout',
  Available_Inventory = 'Available Inventory',
  PC_Package = 'PC Package',
  Options = 'Options',
  SMS_Blast = 'SMS Blast',
  Minigame = 'Minigame',
  EventCode = 'Event Code',
  EventSubscriptions = 'Event Subscriptions',
  KachiPoints = 'Kachi Points',
  Stock_Transfer = 'Transfer Stock',
  Transfer_Logs = 'Transfer Logs',
  Out_Of_Stock = 'Out Of Stock',
  Decaying_Stock = 'Decaying Stock',
  Fast_Moving_Products = 'Fast Moving Products',
  Blogs = 'Blogs',
  Games = 'Games',
  PC_Bundles = 'PC Bundles',
  Vouchers = 'Vouchers',
  Blog_Category = 'Blog Category',
  Shipping_Fee_Calculator = 'Shipping Calculator',
  Promotional = 'Promotionals',
  Sell_Out = 'Sell Out',
  Cheque_Management = 'Cheque Management',
  Tax_Certification = 'Tax Certification',
  Emailer = 'Emailer',
  CustomerPayment = 'Customers Payment'
}

export type DrawerItemSection = {
  sectionTitle: string;
  sectionItems: DrawerItem[];
};
